import React from 'react';
import { SharingLink } from '../../../api';
import { createHref } from '../../sharing/model';

export const LinkRender = ({ id, is_active }: SharingLink) => {
  const href = createHref(id);

  // Неактивная ссылка ведёт на страницу с ошибкой загрузки, поэтому не даём по
  // ней кликнуть; ссылку всё ещё можно восстановить через выбор строки (MYUA-16368).
  if (!is_active) {
    return <span className="al-sharing-links__link_inactive">{href}</span>;
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {href}
    </a>
  );
};
